import { CampaignRouletteStatus } from '@/@types/campaign-roulette';

export type CampaignStatus = CampaignRouletteStatus;

export const STATUS_COLORS = {
  [CampaignRouletteStatus.ATIVA]: "bg-emerald-100 text-emerald-800 border-emerald-200",
  [CampaignRouletteStatus.INATIVA]: "bg-slate-100 text-slate-700 border-slate-200",
  [CampaignRouletteStatus.AGENDADA]: "bg-amber-100 text-amber-800 border-amber-200",
  [CampaignRouletteStatus.ENCERRADA]: "bg-red-100 text-red-800 border-red-200",
} as const;

export const STATUS_LABELS = {
  [CampaignRouletteStatus.ATIVA]: "Ativa",
  [CampaignRouletteStatus.INATIVA]: "Inativa",
  [CampaignRouletteStatus.AGENDADA]: "Agendada",
  [CampaignRouletteStatus.ENCERRADA]: "Encerrada",
} as const;

export function calculateCampaignStatus(
  startDate: string,
  endDate: string,
  isDeleted: boolean = false
): CampaignStatus {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Parse dates safely to avoid timezone issues
  const [startYear, startMonth, startDay] = startDate.split('T')[0].split('-');
  const start = new Date(Number(startYear), Number(startMonth) - 1, Number(startDay));
  start.setHours(0, 0, 0, 0);
  
  const [endYear, endMonth, endDayFull] = endDate.split('T')[0].split('-');
  const end = new Date(Number(endYear), Number(endMonth) - 1, Number(endDayFull));
  end.setHours(23, 59, 59, 999);
  
  if (isDeleted) {
    return CampaignRouletteStatus.INATIVA;
  }
  
  if (today < start) {
    return CampaignRouletteStatus.AGENDADA;
  }
  
  if (today > end) {
    return CampaignRouletteStatus.ENCERRADA;
  }
  
  return CampaignRouletteStatus.ATIVA;
}

export function isCampaignActive(status: CampaignStatus): boolean {
  return status === CampaignRouletteStatus.ATIVA;
}

export function isCampaignEditable(status: CampaignStatus): boolean {
  return status === CampaignRouletteStatus.AGENDADA || status === CampaignRouletteStatus.ATIVA;
}

export function getStatusDescription(status: CampaignStatus): string {
  return STATUS_LABELS[status];
}

export function getStatusColor(status: CampaignStatus): string {
  return STATUS_COLORS[status];
}
